<template lang="pug">
  include ./../../vuek/mixins.pug

  +b.SECTION.t-section
    slot
</template>

<script>
export default {
  name: 't-section',
};
</script>


<style lang="scss">
@import '../../scss/styles';

.t-section {
  position: relative;
  width: 100%;
  padding-top: 64px;
  padding-bottom: 64px;
  // border-bottom: 1px solid rgba(0,0,0,0);
}
</style>



// WEBPACK FOOTER //
// src/components/TSection/TSection.vue